import { environmentHttpClient } from "client/Api/httpClient";

export type LiquitConnectionModel = {
	id: number;
	name: string;
	portalUrl: string;
	identitySource: string;
	applicationId: string;
};

export type LiquitConnectionListItemModel = {
	id: number;
	name: string;
	portalUrl: string;
};

export type LiquitConnectionSaveModel = {
	name: string;
	portalUrl: string;
	identitySource: string;
	applicationId: string;
};

export type NewConnectionLiquitSaveResultModel = {
	connectionId: number;
};

export function list(
	signal?: AbortSignal
): Promise<ReadonlyArray<LiquitConnectionListItemModel>> {
	return environmentHttpClient.get<ReadonlyArray<LiquitConnectionListItemModel>>(
		"UiApi/LiquitConfiguration/List",
		undefined,
		{ signal }
	);
}

export function get(
	id: number,
	signal?: AbortSignal
): Promise<LiquitConnectionModel> {
	return environmentHttpClient.get<LiquitConnectionModel>(
		`UiApi/LiquitConfiguration/${id}`,
		undefined,
		{
			signal
		}
	);
}

export function create(model: LiquitConnectionSaveModel, signal?: AbortSignal): Promise<NewConnectionLiquitSaveResultModel> {
	return environmentHttpClient.post<NewConnectionLiquitSaveResultModel>(
		"UiApi/LiquitConfiguration",
		model,
		{ signal }
	);
}

export function update(
	id: number,
	model: LiquitConnectionSaveModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		`UiApi/LiquitConfiguration/${id}`,
		model,
		{ signal }
	);
}

export function deleteMultiple(
	ids: ReadonlyArray<number>,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.delete<void>(
		"UiApi/LiquitConfiguration",
		ids,
		{ signal }
	);
}
